<template>
  <div class="town-list">
    <v-btn
      v-for="town in towns"
      :key="town.name"
      data-qa="dialog-town-item"
      class="d-flex justify-start text--text pa-3 cursor-pointer"
      color="text"
      text
      block
      @click="redirectTown(town)"
    >
      <span
        class="text--text"
        :class="textStyle"
      >
        {{ transDynamic(town, `name,${language},${needTranslate}`) }}
      </span>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { Town, Country } from 'www/vue_components/desktop/ChooseTownDialog/types'

defineProps<{
  towns: Town[] | Country[],
  textStyle: string,
}>()

const emit = defineEmits(['click:redirect'])

const { language } = I18NextVue
const needTranslate = true

function redirectTown(town: Town | Country) {
  emit('click:redirect', town)
}
</script>

<style scoped lang="scss">
.town-list {
  column-count: 3;
}
</style>
